import { render, staticRenderFns } from "./TheHead.vue?vue&type=template&id=25940f3c&scoped=true&"
import script from "./TheHead.vue?vue&type=script&lang=js&"
export * from "./TheHead.vue?vue&type=script&lang=js&"
import style0 from "./TheHead.vue?vue&type=style&index=0&id=25940f3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25940f3c",
  null
  
)

export default component.exports